import { motion } from "framer-motion";
import { GALLERY } from "@/lib/content";

const EASE = [0.22, 1, 0.36, 1];

// Curated masonry layout — mixes wide + tall frames like an editorial gallery
const LAYOUTS = [
  "md:col-span-7 aspect-[16/10]",
  "md:col-span-5 aspect-[4/5]",
  "md:col-span-5 aspect-[4/5]",
  "md:col-span-7 aspect-[16/10]",
  "md:col-span-6 aspect-[3/2]",
  "md:col-span-6 aspect-[3/2]",
  "md:col-span-4 aspect-[4/5]",
  "md:col-span-4 aspect-[4/5]",
  "md:col-span-4 aspect-[4/5]",
];

export default function Projects() {
  return (
    <section
      id="work"
      className="relative bg-[color:var(--te-bg)] px-5 md:px-10 py-24 md:py-32 border-t border-white/10"
      data-testid="projects-section"
    >
      <div className="max-w-[1440px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14 md:mb-20">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-2 h-2 bg-[color:var(--te-primary)] rotate-45" />
              <span className="text-[11px] uppercase tracking-[0.28em] text-[color:var(--te-primary)] font-display">
                Selected work
              </span>
            </div>
            <h2
              className="font-display font-black uppercase text-white tracking-tighter leading-[0.9]"
              style={{ fontSize: "clamp(2.4rem, 6vw, 5.5rem)" }}
            >
              Delivered <br />
              <span className="font-serif-italic tracking-normal text-[color:var(--te-primary)]">across QLD.</span>
            </h2>
          </div>
          <p className="max-w-md text-white/60 font-body text-base md:text-lg leading-relaxed">
            A quiet portfolio — pads that hold, drainage that runs, culverts and stormwater that survive the wet season.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6">
          {GALLERY.map((p, i) => (
            <motion.article
              key={p.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.9, ease: EASE, delay: (i % 3) * 0.08 }}
              className={`clip-frame relative w-full ${LAYOUTS[i % LAYOUTS.length]} bg-black/40 group overflow-hidden`}
              data-testid={`project-card-${i + 1}`}
            >
              <img
                src={p.img}
                alt={p.title}
                className="w-full h-full object-cover scale-105 group-hover:scale-110 transition-transform duration-[1600ms]"
                style={{ filter: "brightness(1.02) contrast(1.06) saturate(1.08)" }}
                loading="lazy"
              />
              {/* Vignette blend */}
              <div
                className="pointer-events-none absolute inset-0"
                style={{
                  background:
                    "radial-gradient(120% 90% at 50% 35%, transparent 55%, rgba(10,10,10,0.45) 100%)",
                }}
              />
              {/* Bottom shade for caption legibility */}
              <div className="pointer-events-none absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />

              <div className="absolute inset-x-0 bottom-0 p-5 md:p-7 flex items-end justify-between gap-4 z-10">
                <div className="min-w-0">
                  <div className="text-[10px] uppercase tracking-[0.28em] text-[color:var(--te-primary)] font-display mb-2">
                    {p.type}
                  </div>
                  <h3 className="font-display font-bold uppercase text-white text-xl md:text-2xl lg:text-3xl leading-tight tracking-tight">
                    {p.title}
                  </h3>
                  <div className="mt-1 text-[10px] md:text-[11px] uppercase tracking-[0.24em] text-white/60 font-display">
                    {p.location}
                  </div>
                </div>
                <div className="text-[10px] uppercase tracking-[0.28em] text-white/70 font-display shrink-0 pb-1">
                  {p.year}
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
